<template>
  <SjDropdown
    :class="['sj-dropdown_menu', { disabled }]"
    v-bind="finalDropdownProps"
    v-on="$listeners"
    :disabled="disabled"
    @show="
      show = true;
      $emit('show');
    "
    @hide="
      show = false;
      $emit('hide');
    "
  >
    <span slot="reference" class="trigger" :class="{ show, disabled }">
      <slot>
        <span class="text">{{ label }}</span>
      </slot>
      <i
        v-if="showArrow"
        class="icon_com icon"
        :class="[show ? 'comselect_back' : 'comselect_expand']"
      />
    </span>
    <SjMenu v-bind="menuProps" slot="dropdown" v-on="$listeners" />
  </SjDropdown>
</template>

<script>
/**
 * card组件，为一个可自定义内容的显示区域，无额外功能。
 */
export default {
  name: "SjDropdownMenu",
  props: {
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dropdownProps: {
      type: Object,
      default() {
        return {};
      }
    },
    showArrow: {
      default: true,
      type: Boolean
    },
    menuProps: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    finalDropdownProps() {
      return {
        placement: "bottom",
        trigger: "click",
        arrowVisible: false,
        customStyle: true,
        ...this.dropdownProps
      };
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.sj-dropdown_menu {
  .trigger {
    display: inline-flex;
    align-items: center;
    .text("caption", "normal");
    cursor: pointer;
    &.disabled {
      .text("caption", "light");
      cursor: not-allowed;
    }
    &:not(.disabled) {
      &.show,
      &:hover {
        .text("caption", "available");
      }
    }
    .text {
    }
    .icon {
      margin-left: 5px;
      font-size: 12px;
    }
  }
}
</style>
